import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { useScatterplotContext } from 'features/timeSeries'
import {
  DateInputRow,
  DateInputsContainer,
  DateLabel,
} from 'features/timeSeries/sharedStyles'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const StyledDatePicker = styled(DatePicker)`
  background-color: ${({ theme }) => theme.forecast.defaultButton};
`

export const AbsoluteDateConfig: React.FC = () => {
  const { timeRange, setTimeRange } = useScatterplotContext()
  const [startDate, setStartDate] = useState<Dayjs | null>(
    dayjs(timeRange.from)
  )
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(timeRange.to))

  useEffect(() => {
    setStartDate(dayjs(timeRange.from))
    setEndDate(dayjs(timeRange.to))
  }, [timeRange.from, timeRange.to])

  const handleStartDateChange = (date: unknown) => {
    if (dayjs.isDayjs(date)) {
      setStartDate(date)
      setTimeRange({
        ...timeRange,
        from: date.toISOString(),
        preset: 'custom',
      })
    }
  }

  const handleEndDateChange = (date: unknown) => {
    if (dayjs.isDayjs(date)) {
      setEndDate(date)
      setTimeRange({
        ...timeRange,
        to: date.toISOString(),
        preset: 'custom',
      })
    }
  }

  return (
    <DateInputsContainer>
      <DateInputRow>
        <DateLabel>Start Date</DateLabel>
        <StyledDatePicker
          showTime
          format='M/D/YYYY HH:mm:ss'
          value={startDate}
          onChange={handleStartDateChange}
          placeholder='Select start date'
        />
      </DateInputRow>
      <DateInputRow>
        <DateLabel>End Date</DateLabel>
        <StyledDatePicker
          showTime
          format='M/D/YYYY HH:mm:ss'
          value={endDate}
          onChange={handleEndDateChange}
          placeholder='Select end date'
        />
      </DateInputRow>
    </DateInputsContainer>
  )
}
